import { Box, createStyles, LoadingOverlay } from '@mantine/core';
import React, { useMemo } from 'react';
import { useParams } from 'react-router';
import { Redirect } from 'react-router-dom';

import { OrderType, useOrderById } from '@portals/api/partners';
import { GenericContextProvider } from '@portals/framework';
import {
  RouteModal,
  useRouteModalConfig,
} from '@portals/framework/route-modals';

import { OrderContent } from './OrderContent';
import { OrderHeader } from './OrderHeader';

export function Order() {
  const contentStyles = useStyles();
  const defaultBackgroundPath = useRouteModalConfig('order').backgroundPath;

  const { order_id } = useParams<{ order_id: string }>();

  const order = useOrderById(order_id);

  const content = useMemo(() => {
    if (!order_id) {
      return <Redirect to={defaultBackgroundPath} />;
    }

    if (!order.isFetched) {
      return <LoadingOverlay visible />;
    } else if (!order) {
      return <Redirect to={defaultBackgroundPath} />;
    }

    return (
      <>
        <OrderHeader />

        <OrderContent />
      </>
    );
  }, [defaultBackgroundPath, order, order_id]);

  return (
    <RouteModal modalId="order">
      <GenericContextProvider<OrderType> value={order?.data}>
        <Box className={contentStyles.classes.container}>{content}</Box>
      </GenericContextProvider>
    </RouteModal>
  );
}

const useStyles = createStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'min-content 1fr',
  },
}));
